module.exports = __webpack_public_path__ + "img/text1_zhCn@3x.1f1ceaa6.png";